import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { GestationalAge } from "../../GestationalAge";

class BritishColumbiaObstetricalFileUltrasound extends JsonSerializable {
    private id: number;

    public Date: Date;
    public GestationalAge: GestationalAge;
    public GestationalAgeByUltrasound: GestationalAge;
    public Comment: string;
    public UseForEstimatedDateOfBirth: boolean = null;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileUltrasound>) {
        super({ excludedFields: ["id"] });
        Object.assign(this, fields);

        this.id = sessionStore.newId();
        this.GestationalAge = new GestationalAge(fields?.GestationalAge);
        this.GestationalAgeByUltrasound = new GestationalAge(fields?.GestationalAgeByUltrasound);
        this.Date = LuxonDateTimeParser.parse(fields?.Date)?.toJSDate();
    }

    public getId(): number {
        return this.id;
    }

    public isUseForEstimatedDateOfBirthDisabled(): boolean {
        return !this.Date
            || !this.GestationalAgeByUltrasound.hasValue();
    }

    public hasValue(): boolean {
        return !!this.Date
            || this.GestationalAge?.hasValue()
            || this.GestationalAgeByUltrasound?.hasValue()
            || !!this.UseForEstimatedDateOfBirth
            || !!this.Comment;
    }
}

export { BritishColumbiaObstetricalFileUltrasound };
